

import { batch } from 'react-redux';
import { AvaliacaoAction } from 'store/Avaliacao/Avaliacao.action';
import { AvaliacaoPersistida } from 'model/solicitacao/avaliacao/AvaliacaoPersistida';
import { SolicitacaoCorrenteAction } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.action';
import { ComentariosSolicitacaoAction } from 'store/ComentariosSolicitacao/ComentariosSolicitacao.action';
import { SolicitacaoReaberta } from 'model/solicitacao/reabertura/SolicitacaoReaberta';
import { NotificacoesAction } from 'view/extrair/Notificacao/store/Notificacoes/Notificacoes.action';
import { AppDispatch } from 'store/store';
import { SolicitacaoResumida } from 'model/solicitacao/SolicitacaoResumida';
import { AvaliacaoCamposFormulario } from '../formulario/AvaliacaoFormulario';
import { ReaberturaCamposFormulario } from '../formulario/ReaberturaFormulario';
import { Situacoes } from 'model/solicitacao/Situacao';
import { SituacaoTag } from 'view/component/Situacao/SituacaoTag';
import { Avaliacao } from 'model/solicitacao/avaliacao/Avaliacao';


/**
 * Actions específicos para o Avaliação Modal
 * 
 * Os atos de finalizar e de reabrir implicam em atualização de diversos componentes.
 * Os actions agrupados aqui centralizam esse trabalho
 */
export class AvaliacaoModalAction {
  static finalizarSolicitacao(solicitacao: SolicitacaoResumida, formulario: AvaliacaoCamposFormulario) {
    const nota = parseInt(formulario.notaAvaliacao);
    const alerta = {titulo: "Solicitação atendida com sucesso!", mensagem: <>A solicitação agora está <SituacaoTag situacao={Situacoes.FECHADO} /></>}
  
    return async (dispatch: AppDispatch) => {
      const avaliacao: AvaliacaoPersistida = await dispatch(AvaliacaoAction.formulario.avaliar(solicitacao.id, nota, formulario.comentario)).unwrap();
      const avaliacaoAInserirNaLista: Avaliacao = {
        ...avaliacao,
        idSolicitacao: avaliacao.solicitacao.id,
        idComentario: avaliacao.comentario?.id
      }

      return batch(() => {
        if (avaliacao.comentario) {
          dispatch(ComentariosSolicitacaoAction.lista.adicionarNaLista(avaliacao.comentario));
        }
        dispatch(SolicitacaoCorrenteAction.visualizacao.atualizar(avaliacao.solicitacao))
        dispatch(NotificacoesAction.lista.exibirAlerta(alerta));
        dispatch(AvaliacaoAction.lista.incluirAvaliacao(avaliacaoAInserirNaLista));
      })
    }
  }

  static reabrirSolicitacao(solicitacao: SolicitacaoResumida, formulario: ReaberturaCamposFormulario) {
    const alerta = {titulo: "Solicitação reaberta", mensagem: <>A solicitação agora está <SituacaoTag situacao={Situacoes.EM_ABERTO} /></>}

    return async (dispatch: AppDispatch) => {
      const solicitacaoReaberta: SolicitacaoReaberta = await dispatch(AvaliacaoAction.formulario.reabrirSolicitacao(solicitacao.id, formulario.comentario)).unwrap();

      return batch(() => {
        dispatch(ComentariosSolicitacaoAction.lista.adicionarNaLista(solicitacaoReaberta.justificativa))
        dispatch(SolicitacaoCorrenteAction.visualizacao.atualizar(solicitacaoReaberta.solicitacao))
        dispatch(NotificacoesAction.lista.exibirAlerta(alerta));
      });
    }
  }
}
